interface TagProps {
  label: string;
}

export function Tag({ label }: TagProps) {
  return (
    <div className="bg-bg-grayblue text-font-grayblue typo-16 rounded-md px-4 py-3">
      {label}
    </div>
  );
}
